/*
 * @Author: zhangliang
 * @Date: 2020-01-30 19:35:33
 * @LastEditTime: 2020-03-20 16:21:46
 * @LastEditors: zhangliang
 * @Description:
 * @FilePath: \asset_app\src\store\index.js
 */
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: "",
    activeOrg: {}, // 当前选中组织
    activeType: {} // 当前选中分类
  },
  mutations: {
    setToken(state, data) {
      state.token = data;
    },
    setActiveOrg(state, data) {
      state.activeOrg = data;
    },
    setActiveType(state, data) {
      state.activeType = data;
    }
  },
  getters: {
    getToken(state) {
      return state.token;
    },
    getActiveOrg(state) {
      return state.activeOrg;
    },
    getActiveType(state) {
      return state.activeType;
    }
  }
});
